export default {
    "59": {
        "ID": 59,
        "InfoComment": "Dieses Konzert findet im Rahmen des \"Marsch des Lebens\" statt. Informationen unter <a href='http://marschdeslebens.org/'>marschdeslebens.org</a>. Reservierung unter <a href='mailto: uta.lang@kisi.at'>uta.lang@kisi.at</a>. Freiwillige Spende."
    },
    "68": {
        "ID": 68,
        "InfoComment": "Dieses Konzert ist eine Schulaufführung."
    },
    "69": {
        "ID": 69,
        "InfoComment": "Dieses Konzert ist eine Schulaufführung."
    }
}


// WEBPACK FOOTER //
// ./src/components/Content/Performances.js